var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fieldset"},[_c('h3',{staticClass:"fieldset-heading"},[_vm._v("Pets")]),_c('PetsYN',{model:{value:(_vm.form.pets),callback:function ($$v) {_vm.$set(_vm.form, "pets", $$v)},expression:"form.pets"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }